// removed by extract-text-webpack-plugin
module.exports = {"label":"input-field-simple__label___2Qnd3","wrapper":"input-field-simple__wrapper___1_ivW","is-error":"input-field-simple__is-error___278hQ","input":"input-field-simple__input___2D0vn","has-help":"input-field-simple__has-help___1OlGu","icon":"input-field-simple__icon___O0ZRo","icon-error":"input-field-simple__icon-error___1NH37","icon-help":"input-field-simple__icon-help___35iPf"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/input-field/input-field-simple.scss
 ** module id = 1301
 ** module chunks = 1
 **/